export default __webpack_public_path__ + "static/media/studies_icon.586c451c.svg";